const hasCorrectChars = (val: string, amount: number): boolean => val.length >= amount;

export default hasCorrectChars;
